import { RsoDetailPage } from "@/features/rso/pages/RsoDetail";

const RsoDetail = () => {
  return <RsoDetailPage />;
};

export default RsoDetail;
